import { Component, Input } from '@angular/core';
import { BallotReport } from '../../models/reports/ballot-report';

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts;

@Component({
    selector: 'app-generate-report-button',
    templateUrl: './generate-report-button.component.html',
    standalone: false
})
export class GenerateReportButtonComponent {
  @Input() ballotReport: BallotReport | undefined = undefined;

  generateReport() {
    if (this.ballotReport) {
      this.ballotReport.generateReport();
    }
  }
}
